//基础信息
export default [
  {
    path: '/shopGroupManager',
    component: () => import("../pages/shoppingMallManage/shopGroupManager.vue"),
    name: 'MallClassifyManage',
    title: '团购管理',
    meta: {
      title: '团购管理',
    },
  },
  {
    path: '/mallClassifyManage',
    component: () => import("../pages/shoppingMallManage/mallClassifyManage.vue"),
    name: 'MallClassifyManage',
    title: '好物分类',
    meta: {
      title: '好物分类',
    },
  },
  {
    path: '/goodsManage',
    component: () => import("../pages/shoppingMallManage/goodsManage.vue"),
    name: 'Goods',
    title: '好物管理',
    meta: {
      title: '好物管理',
    },
  },
  {
    path: '/commodityAttr',
    component: () => import("../pages/shoppingMallManage/commodityAttr.vue"),
    name: 'Commodityattr',
    title: '属性规格管理',
    meta: {
      title: '属性规格管理',
    },
  },
  {
    path: '/logisticsManage',
    component: () => import("../pages/shoppingMallManage/logisticsManage.vue"),
    name: 'LogisticsMag',
    title: '物流公司管理',
    meta: {
      title: '物流公司管理',
    },
  },
  {
    path: '/logisticsSet',
    component: () => import("../pages/shoppingMallManage/logisticsSet.vue"),
    name: 'LogisticsSet',
    title: '设置物流运费',
    meta: {
      title: '设置物流运费',
    },
  },
  {
    path: '/order',
    component: () => import("../pages/shoppingMallManage/shopOrderManage.vue"),
    name: 'order',
    title: '订单管理',
    meta: {
      title: '订单管理',
    },
  },
  {
    path: '/evaluate',
    component: () => import("../pages/shoppingMallManage/evaluate.vue"),
    name: 'evaluate',
    title: '评价管理',
    meta: {
      title: '评价管理',
    },
  },
  {
    path: '/recoShop',
    component: () => import("../pages/shoppingMallManage/recoShop.vue"),
    name: 'recoShop',
    title: '商品推荐',
    meta: {
      title: '商品推荐',
    },
  },
]
